import { render, staticRenderFns } from "./digitalCertificate.vue?vue&type=template&id=12d22102&scoped=true"
import script from "./digitalCertificate.vue?vue&type=script&lang=js"
export * from "./digitalCertificate.vue?vue&type=script&lang=js"
import style0 from "./digitalCertificate.vue?vue&type=style&index=0&id=12d22102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d22102",
  null
  
)

export default component.exports